export const TRANSLATION_FILES = {
  screens: 'screens',
  constants: 'constants',
  translations: 'translations',
};

export const namespaces = [
  TRANSLATION_FILES.screens,
  TRANSLATION_FILES.constants,
  TRANSLATION_FILES.translations,
];
